import "reflect-metadata";
import 'whatwg-fetch';
import Vue from 'vue';
import VuePlugin from "./VueIntegration/VuePlugin";
import {Slideshow} from "./slideshow";
import App from "./UI/App.vue";
import Tooltip from "./UI/Tooltip";
import {install} from "./VueIntegration/CtrlKeyboardShortcut";
import {Container} from "inversify";
import {Voiceover} from "@/voiceover";
import {ClosedCaptionsService} from "@/ClosedCaptionsService";

export function init(kernel: Container) {
    window.addEventListener('touchmove', function() {}); // workaround for drag and drop scrolling on iOS

    let element = document.getElementById('slideshow');
    if (element == null)
        throw "Could not find slideshow element";

    kernel.get<Voiceover>("Voiceover");
    kernel.get<ClosedCaptionsService>("ClosedCaptionsService");
    let slideshow = kernel.get<Slideshow>("Slideshow");
    const vueInject = VuePlugin(kernel);
    Vue.use(vueInject);
    Vue.use(install);
    Vue.directive('tooltip', Tooltip);

    let promise = slideshow.load();

    let options = {
        slideshow
    };

    const vue = new App(<any> options).$mount(element);

    promise.then(() => (<any>vue).isLoading = false);
}
